module.exports = __webpack_public_path__ + "img/24.72f41676.jpg";